/** @module Enums */ /** typedoc */

/**
 * Noise reduction level used to master video tracks.
 */
export enum NoiseReductionLevelEnum {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High'
}

